import React from 'react';
import MainPage from "./MainPage";


function App() {
  return (
    <div className="App" style={{overflow:"hidden"}}>
        <MainPage />
    </div>
  );
}

export default App;
